export default __webpack_public_path__ + "static/media/get-app-image-1.b739c0d1.png";